import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueLazyload from "vue-lazyload";

Vue.config.productionTip = false;
import "../public/css/style.css";

Vue.use(VueLazyload, {
  lazyComponent: true
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
